import { getQaSelector } from '../../../../utils/common'
import { stopPropagation } from '../../../../utils/events'
import { ICON_COLOR, ICON_HEIGHT_16, IconNG } from '../../../Icon'

import * as styles from './RequestProfileTabActivitiesDragHandle.module.css'

import DragIcon from '../../../../icons/drag-and-drop.svg'

function RequestProfileTabActivitiesDragHandle({
  className = styles.RequestProfileTabActivitiesDragHandle,
  dragHandleProps,
  qaName,
}) {
  return (
    <span
      {...dragHandleProps}
      {...(qaName ? getQaSelector({ value: qaName }) : null)}
      data-drag-handle
      className={className}
      onClick={stopPropagation}
    >
      <IconNG
        Icon={DragIcon}
        color={ICON_COLOR.SecondaryTextColor70}
        size={ICON_HEIGHT_16}
      />
    </span>
  )
}

export default RequestProfileTabActivitiesDragHandle
